/**
 * Payment-app runtime config.
 *
 * This app runs on the display beside a ZVT card reader. `terminalId` identifies
 * *this station's* terminal (the Hardware PaymentTerminal id) — the same id the
 * Raspberry Pi in the column uses. It is provisioned per station, so it lives in
 * config, not code.
 */
export const environment = {
  production: true,
  environment: 'testing',
  client: 'payment-app',
  // LAN IP, never localhost: this app runs in a kiosk browser on the station Pi, where
  // 'localhost' resolves to the Pi itself and every backend call + hub connect fails.
  apiUrl: 'https://api.testing.smartparking.jjames.eu/',
  paymentHubUrl: 'https://api.testing.smartparking.jjames.eu/hubs/payment-terminal',
  /**
   * Station identity. Empty by design in a deployed build: a station is provisioned once via its
   * QR-code URL (`?terminalId=xxx` captured by main.ts into localStorage), so the id belongs to the
   * station, not to the bundle. Baking a real id in here would make every unprovisioned browser that
   * opens this URL act as that one terminal.
   */
  terminalId: '',
  /**
   * API base URL for the settlement page (`/pay/:id`) — the one route in this app that runs on a
   * *parker's own phone* rather than in the column.
   *
   * It must be resolvable from the public internet. `apiUrl` above deliberately is not: it is the
   * station's LAN address, and a phone on mobile data can never reach it. Keeping the two apart is
   * the whole reason this key exists — sharing one would silently break whichever surface lost.
   *
   * In local development both point at the same LAN host, so a phone on the office Wi-Fi can open
   * the page against the dev backend.
   */
  publicApiUrl: 'https://api.testing.smartparking.jjames.eu',
  /**
   * Seconds the success screen stays up before auto-returning to idle. Kept in config, not code, so a
   * station can tune it without a rebuild. TODO: once the backend station-config carries it, prefer that
   * (per-terminal) and fall back to this value.
   */
  autoResetSeconds: 120,
};
